import { useAuth0 } from "@auth0/auth0-react";

export interface SubmagicVideoOutput {
    generative_output_id: string;
    asset_type: string;
    file_id: string;
    permalink: string;
    created_at: string;
    thumbnail_image?: string;
}

export function useSubmagicOutputsAPI() {
    const { getAccessTokenSilently } = useAuth0();
    const API = `${process.env.REACT_APP_API_URL}`;

    const authFetch = async (url: string, init: RequestInit = {}) => {
        const token = await getAccessTokenSilently();
        const res = await fetch(url, {
            ...init,
            headers: {
                ...(init.headers || {}),
                authorization: `Bearer ${token}`,
                ...(init.headers as any)?.["Content-Type"] ? {} : {},
            },
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        return res;
    };

    const listMyVideoOutputs = async (limit = 100, offset = 0): Promise<SubmagicVideoOutput[]> => {
        const res = await authFetch(`${API}/generative-output/my?limit=${limit}&offset=${offset}`);
        const data = (await res.json()) as SubmagicVideoOutput[];
        return Array.isArray(data) ? data.filter(o => o.asset_type === "video") : [];
    };

    return { listMyVideoOutputs };
}
